module.exports = __webpack_public_path__ + "static/img/about1.4aba383.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/about1.png
// module id = oQSU
// module chunks = 1